import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/admin.service';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login-dashboard',
  templateUrl: './login-dashboard.component.html',
  styleUrls: ['./login-dashboard.component.scss']
})
export class LoginDashboardComponent implements OnInit {
  companies : any[];
  hostname=environment.hostname;
  token = localStorage.getItem("token");
  data = localStorage.getItem("data");
  userdetails:any;
  access_list = Object.values(JSON.parse(localStorage.getItem("accesslist") || '{}'));
  
  constructor(private adminService: AdminService, private router: Router) { 
  }

  ngOnInit(): void {
    this.fetchData();
    let user_details = localStorage.getItem('data');
    if (user_details) {
      try {
        this.userdetails = JSON.parse(user_details);
        console.log('Parsed data from localStorage:', this.userdetails);
        // You can now use parsedData as needed
      } catch (error) {
        console.error('Error parsing JSON from localStorage:', error);
      }
    }
  }

  selectCompany(company: string) {
    console.log(` ${company}`);
    
  }

  navigateprofile() {
    this.router.navigate(['/profile']);
  }

  dashboard() {
    this.router.navigate(['/dashboard']);
  }

  redirectToComapany(subdomain:any,company_id:any,company_name:any){
    const targetOrigin = `http://${subdomain}.${this.hostname}`;

    const dataToSend = { "token": this.token,"userdetails":this.userdetails,"access_list":this.access_list,company_id:company_id,"company_name":company_name,"data":this.data };
    this.sendDataToSubdomain(dataToSend,targetOrigin);

  }

   sendDataToSubdomain(senddata: any,companyDomain:any) {
    // console.log(companyDomain,"aaaaaaa");
    const targetUrl =companyDomain;
    
    // Open the target window
    const targetWindow = window.open(targetUrl);
    
    // Convert your data object to a JSON string
    const data = JSON.stringify(senddata);
    
    // Use setTimeout to give the target window some time to load before sending the message
      setTimeout(() => {
        targetWindow.postMessage(data, targetUrl);
      }, 1000);
  }

  fetchData() {
    // const userdetails = JSON.parse(this.userdetails || '{}');
    this.adminService.viewTenantByUser().subscribe(
      (response) => {
        console.log(response,"response")
        this.companies = response;
      },
      (error) => {
        console.error('Error fetching data:', error);
        if(error.status === 401){
          this.logout();
        }
      }
    );
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('data');
    this.router.navigate(['/login']);
    // window.location.reload();
}
}
